var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8999 8.90002L8.8999 13.8M8.8999 48.1L8.8999 43.2M18.6999 8.90002V13.8V18.7M28.4999 8.90002V13.8V18.7M28.4999 48.1V43.2M38.2999 8.90002V13.8V18.7V23.6M38.2999 48.1V43.2V38.3V33.4M18.6999 28.5V33.4V38.3V48.1M28.4999 26.3222V35.5778M48.0999 21.9667V8.90002M48.0999 30.6778V35.5778M8.8999 33.4L8.8999 28.5L8.8999 23.6M48.0999 43.2V48.1",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1001 30.6779V35.5779",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2998 8.90002V13.8V18.7V23.6",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8999 33.4L8.8999 28.5L8.8999 23.6",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 48.1V43.2",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7002 8.90002V13.8V18.7",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoise);
export default __webpack_public_path__ + "static/media/noise.453be815990608021f0fd0bf68c4f16d.svg";
export { ForwardRef as ReactComponent };